import { render, staticRenderFns } from "./unitItem.vue?vue&type=template&id=1ae3d9c1&scoped=true&"
import script from "./unitItem.vue?vue&type=script&lang=js&"
export * from "./unitItem.vue?vue&type=script&lang=js&"
import style0 from "./unitItem.vue?vue&type=style&index=0&id=1ae3d9c1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3d9c1",
  null
  
)

export default component.exports